import { useEffect } from "react";
import { useToast } from "@hiya/ui";
import { listSamplesAtLab, markTabViewed } from "../../../api/orders";
import { useKitList } from "../../../hooks/useKitList";
import { useAssignment } from "../../../hooks/useAssignment";
import { useNotes } from "../../../hooks/useNotes";
import { KitListLayout } from "../../../components/orders/KitListLayout";
import { DoctorActions } from "../../../components/orders/DoctorActions";
import { AssignmentDialogs } from "../../../components/orders/AssignmentDialogs";
import { NotePopover } from "../../../components/orders/NotePopover";
import { formatDate } from "../../../utils/formatDate";

const COLUMNS = ["User Name", "Kit Type", "Day of Cycle", "Order ID", "Kit ID", "Collection", "Lab Received", "Expected", "Notes", "Actions"] as const;

export function SamplesAtLabPage() {
  const { toast, showToast } = useToast();
  const kit = useKitList(listSamplesAtLab);
  const assign = useAssignment({ updateItem: kit.updateItem, showToast });
  const notes = useNotes({ updateItem: kit.updateItem, showToast });

  useEffect(() => {
    markTabViewed("samples_at_lab").catch(() => showToast("Something went wrong. Please refresh the page.", "warning"));
  }, [showToast]);

  return (
    <KitListLayout
      kit={kit}
      toast={toast}
      columns={COLUMNS}
      rowClassName={(item) => (item.is_overdue ? "bg-brand-brown-6" : "")}
      renderRow={(item) => (
        <>
          <td className="px-4 py-3 text-sm text-text-primary">{item.user_name || "-"}</td>
          <td className="px-4 py-3 text-sm text-text-primary">{item.kit_type}</td>
          <td className="px-4 py-3 text-sm text-text-primary">{item.cycle_dayphase || "-"}</td>
          <td className="px-4 py-3 text-sm text-text-primary">{item.order_id}</td>
          <td className="px-4 py-3 text-sm text-text-primary">{item.kit_code}</td>
          <td className="px-4 py-3 text-sm text-text-primary">{formatDate(item.collection_date ?? item.created_at)}</td>
          <td className="px-4 py-3 text-sm text-text-primary">{formatDate(item.updated_at)}</td>
          <td className="px-4 py-3 text-sm text-text-primary">{formatDate(item.expected_date ?? "")}</td>
          <td className="px-4 py-3">
            <NotePopover
              note={item.note}
              onSave={(text) => notes.handleSaveNote(item.record_id, text, !!item.note)}
              onDelete={() => notes.handleDeleteNote(item.record_id)}
            />
          </td>
          <td className="px-4 py-3">
            <DoctorActions kit={item} onAssign={assign.handleAssign} onReassign={assign.handleReassign} onUnassign={assign.handleUnassign} />
          </td>
        </>
      )}
    >
      <AssignmentDialogs assign={assign} />
    </KitListLayout>
  );
}
